export default __webpack_public_path__ + "static/media/neighborhood-svgrepo-com.0d1a562b.svg";